module.exports = __webpack_public_path__ + "media/images/products/cards/bolsa_3.0-4dbbd675761476e7222bda587f099a8a.png";